'use client';

import { useTranslations } from 'next-intl';

/**
 * Translated header band for the course catalog page. The catalog grid itself
 * (CatalogClientWrapper / CatalogEmptyState) is out of scope for this pass.
 */
export function CoursesHero() {
  const t = useTranslations('public.courses');
  return (
    <section className="relative overflow-hidden bg-[var(--eifo-bg-light)] py-12 md:py-16">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full bg-eifo-accent/20 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-eifo-orange/10 blur-3xl"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold text-eifo-primary md:text-5xl">
          {t('heroTitle')}
        </h1>
        <p className="mt-3 text-lg text-gray-600">{t('heroSubtitle')}</p>
      </div>
    </section>
  );
}
